import { render, staticRenderFns } from "./DashboardView_Pools.vue?vue&type=template&id=f79c6842&scoped=true&"
import script from "./DashboardView_Pools.vue?vue&type=script&lang=js&"
export * from "./DashboardView_Pools.vue?vue&type=script&lang=js&"
import style0 from "./DashboardView_Pools.vue?vue&type=style&index=0&id=f79c6842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79c6842",
  null
  
)

export default component.exports